module.exports = require("@splunk/visualization-context/MockedProvider");